import type { DatosGenerales } from "@/lib/types";
import { KV } from "./KV";

/** Contenido del accordion "Datos generales" en el tab Resumen. */
export function DatosGeneralesContent({ dg }: { dg: DatosGenerales }) {
  return (
    <div className="grid grid-cols-1 gap-4 sm:grid-cols-2">
      <KV label="Motivo" value={dg.motivoPago} />
      <KV
        label="Periodo de servicio"
        value={`${dg.periodoServicioInicio} → ${dg.periodoServicioFin}`}
      />
      <KV label="Área" value={dg.areaNombre} />
      {dg.comentarios && <KV label="Comentarios" value={dg.comentarios} />}
    </div>
  );
}
